import React, {useEffect, useState} from 'react';
import { ListItem, ListItemContent, Box } from "@mui/joy";
import { Button } from '../Button';

import { useTranslation } from 'react-i18next'
import PersonAvatar from '../Snippet/PersonAvatar';
import { Icon } from '../../assets';
import { useDrawer } from '../Drawer'
import { Tag } from '../Snippet';
import JSONPretty from 'react-json-pretty';
import 'react-json-pretty/themes/monikai.css';
import { useDataProvider } from 'src/mtska-frontend-data-provider';


const RelationshipEmployment = ({ k, v, name, editing, detailInspector = true, handleItemDetail, handleItemRemove, setValue, loadingDissociation }) => {
    const { t } = useTranslation();
    const { item:personLoaded, loadOne:loadOnePerson, success:successPerson, loading:loadingPerson } = useDataProvider('persons/person');

    // hack veloce per modellare v se lo ricevo dalla scheda person. Noi vogliamo un employment idratato con person ma riceviamo person
    /**
     * @todo fix this shit
     */
    if (typeof v.person_id == 'undefined' && v.employment) {
        const oldv = v;
        v = {
            ...oldv.employment,
            'person': {
                _id: oldv._id,
                firstname: oldv.firstname,
                lastname: oldv.lastname,
                picture: {
                    url: oldv?.person?.picture?.url
                }
            }
        };

        setValue('employment', v);
    }


    const [person, setPerson] = useState();
    useEffect(() => {
        if (v.person) {
            setPerson(v.person)
        } else if (v.person_id) {
            loadOnePerson(v.person_id);
        }
    }, [v]);

    useEffect(() => {
        if (!personLoaded) return;
        setPerson(personLoaded.data);
    }, [personLoaded]);

    return (
        <>
            {/*
            <JSONPretty data={person} className="json-wrapper"></JSONPretty>
            <JSONPretty data={name} className="json-wrapper"></JSONPretty> 
            */}

            <ListItem k={k} variant="outlined" className={"relationship-element"}>
                <ListItemContent className={"relationship-element-content"}>
                    {
                        person ?
                            <PersonAvatar firstname={person?.firstname} lastname={person?.lastname} url={person?.picture?.url} withname={true} item={person} />
                            :
                            <Box className={"status"}>
                                <Tag color={"danger"} title={t("Missing person in employment")}><Icon icon="faWarning" />{t('Missing')}</Tag>
                            </Box>
                    }


                    <Box className="coupled">
                        <Box className="label">{t('Role')}</Box>
                        <Box className="value">
                            <span>{v?.role}</span>
                        </Box>
                    </Box>

                    <Box className={"status"}>
                        <Tag color={v?.status != "terminated" ? "success" : "danger"} title={t("Missing person in employment")}><Icon icon="faWarning" />{t(v?.status)}</Tag>
                    </Box>
                </ListItemContent>

                {editing && handleItemDetail && detailInspector && (<Button onClick={() => handleItemDetail(v)} icon="faPen" variant="plain" />)}
                {(editing && handleItemRemove) && (<Button onClick={() => handleItemRemove(v)} icon="faClose" variant="plain" loading={loadingDissociation} />)}
            </ListItem>
        </>
    )
}

export default RelationshipEmployment



